import { render } from "./BeatsList.vue?vue&type=template&id=0906dd88"
import script from "./BeatsList.vue?vue&type=script&lang=js"
export * from "./BeatsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__